import { createFileRoute, redirect } from "@tanstack/react-router";
import { useAuth } from "@/features/auth/hooks/useAuth";
import { getDefaultRoute } from "@/features/auth/lib/page-routes";

export const Route = createFileRoute("/")({
  beforeLoad: () => {
    const { isAuthenticated, tenants, lastVisitedRoute } = useAuth.getState();
    if (isAuthenticated) {
      const dest = getDefaultRoute(tenants, lastVisitedRoute);
      throw redirect({ to: dest ?? "/login" });
    }
    throw redirect({ to: "/login" });
  },
});
